import { Popover, Transition } from "@headlessui/react"
import { MenuIcon, XIcon } from "@heroicons/react/outline"
import { Link } from "gatsby"
import React, { Component, Fragment } from "react"
import Logo from "./logo"
import DemoVideoModal from "../components/demo-video-modal"

const NavLink = props => {
  if (props.onClick) {
    return (
      <button
        onClick={() => props.onClick()}
        className={`${props.className} focus:outline-none outline-none`}
      >
        {props.children}
      </button>
    )
  } else {
    return (
      <Link to={props.url} className={props.className}>
        {props.children}
      </Link>
    )
  }
}

const getLinksByPosition = (position, links) =>
  links.filter(e => e.navPosition === position)

export default class Nav extends Component {
  constructor(props) {
    super(props)
    this.state = {
      atTopOfPage: true,
      demoVideoOpen: false,
      bannerOpen: false,
    }
    this.updateAtTopOfPage = this.updateAtTopOfPage.bind(this)
  }
  updateAtTopOfPage() {
    this.setState({ atTopOfPage: window.pageYOffset === 0 })
  }
  componentDidMount() {
    window.addEventListener("scroll", this.updateAtTopOfPage)
    this.updateAtTopOfPage()
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.updateAtTopOfPage)
  }
  render() {
    const links = [
      {
        navPosition: "left",
        content: <Logo />,
        url: "/",
      },
      {
        navPosition: "right-secondary",
        content: "Take a Tour",
        onClick: () => this.setState({ demoVideoOpen: true }),
      },
      {
        navPosition: "center",
        content: "Product Overview",
        url: "/solutions",
      },
      // {
      //   navPosition: "center",
      //   content: "Meet The Team",
      //   url: "/team",
      // },
      {
        navPosition: "center",
        content: "Our Story",
        url: "/about",
      },
      {
        navPosition: "right",
        content: "Request a Demo",
        url: "/request-a-demo",
      },
    ]

    return (
      <header
        className={`sticky top-0 w-full z-50 transition-all ${
          this.state.atTopOfPage ? "" : "shadow-md"
        }`}
      >
        {this.state.bannerOpen ? (
          <div className="relative bg-gray-700 hidden md:block">
            <div className="max-w-7xl mx-auto py-2 px-3 sm:px-6 lg:px-8">
              <div className="pr-16 sm:text-center sm:px-16">
                <p className="font-medium text-white">
                  <span className="md:hidden">
                    We're looking for new team members!
                  </span>
                  <span className="hidden md:inline">
                    Interested in working with us? We're looking for new team
                    members!
                  </span>
                  <span className="block sm:ml-2 sm:inline-block">
                    <Link
                      to="/work-with-us"
                      className="text-white font-bold underline"
                    >
                      {" "}
                      Learn more <span aria-hidden="true">&rarr;</span>
                    </Link>
                  </span>
                </p>
              </div>
              <div className="absolute inset-y-0 right-0 pt-1 pr-1 flex items-start sm:pt-1 sm:pr-2 sm:items-start">
                <button
                  type="button"
                  className="flex p-1.5 rounded-md hover:bg-gray-600 focus:outline-none"
                  onClick={() => this.setState({ bannerOpen: false })}
                >
                  <span className="sr-only">Dismiss</span>
                  <XIcon className="h-5 w-5 text-white" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.demoVideoOpen ? (
          <DemoVideoModal
            closeModal={() => this.setState({ demoVideoOpen: false })}
          />
        ) : null}
        <Popover className="bg-white">
          {({ open }) => (
            <>
              <div className="flex justify-between items-center max-w-7xl mx-auto px-4 py-6 px-6 md:justify-start md:space-x-10 xl:px-0">
                <div className="flex justify-start">
                  {getLinksByPosition("left", links).map(e => (
                    <NavLink {...e}>{e.content}</NavLink>
                  ))}
                  <Popover.Group
                    as="nav"
                    className={`transition-all hidden md:flex justify-center items-center space-x-6 ml-10`}
                  >
                    {getLinksByPosition("center", links).map(e => (
                      <NavLink
                        {...e}
                        className="transition-all text-base font-medium text-gray-500 hover:text-gray-900"
                      >
                        {e.content}
                      </NavLink>
                    ))}
                  </Popover.Group>
                </div>
                <div className="-mr-2 -my-2 md:hidden">
                  <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-default-500">
                    <span className="sr-only">Open menu</span>
                    <MenuIcon className="h-6 w-6" aria-hidden="true" />
                  </Popover.Button>
                </div>
                <div className="hidden md:flex items-center justify-end md:flex-1">
                  {getLinksByPosition("right-secondary", links).map(e => (
                    <NavLink
                      {...e}
                      className="transition-all text-base font-medium text-default-500 hover:text-default-600 hover:bg-default-200 py-2 px-4 mr-2 inline-flex items-center justify-center rounded-md"
                    >
                      {e.content}
                    </NavLink>
                  ))}
                  {getLinksByPosition("right", links).map(e => (
                    <NavLink
                      {...e}
                      className="transition-all whitespace-nowrap inline-flex items-center justify-center px-4 py-2 rounded-md text-base font-medium text-white bg-default-600 hover:bg-default-700"
                    >
                      {e.content}
                    </NavLink>
                  ))}
                </div>
              </div>

              <Transition
                show={open}
                as={Fragment}
                enter="duration-200 ease-out"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="duration-100 ease-in"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Popover.Panel
                  focus
                  static
                  className="absolute z-30 top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
                >
                  <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
                    <div className="pt-5 pb-6 px-5">
                      <div className="flex items-center justify-between">
                        {getLinksByPosition("left", links).map(e => (
                          <NavLink {...e} className="focus:outline-none">
                            {e.content}
                          </NavLink>
                        ))}
                        <div className="-mr-2">
                          <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-default-500">
                            <span className="sr-only">Close menu</span>
                            <XIcon className="h-6 w-6" aria-hidden="true" />
                          </Popover.Button>
                        </div>
                      </div>
                    </div>
                    <div className="py-6 px-5">
                      <div className="grid grid-cols-1 gap-1">
                        {getLinksByPosition("center", links)
                          .concat(getLinksByPosition("right-secondary", links))
                          .map(e => (
                            <NavLink
                              {...e}
                              className="text-base py-2 font-medium text-gray-900 hover:text-gray-700 text-left"
                            >
                              {e.content}
                            </NavLink>
                          ))}
                      </div>
                      <div className="mt-6">
                        {getLinksByPosition("right", links).map(e => (
                          <NavLink
                            {...e}
                            className="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-gradient-to-r from-default-600 to-default-600 hover:from-default-700 hover:to-default-700"
                          >
                            {e.content}
                          </NavLink>
                        ))}
                      </div>
                    </div>
                  </div>
                </Popover.Panel>
              </Transition>
            </>
          )}
        </Popover>
      </header>
    )
  }
}
